import { createSelector } from 'reselect';

const getChainId = (state) => state.businessApp.chainId;
const getRestaurants = (state) => state.businessApp.restaurants;

export const getChainMenuId = createSelector(
    [getChainId, getRestaurants],
    (chainId, restaurants) => {
        const restaurant = restaurants.find(rest => rest.ownerId === chainId);

        return restaurant ? restaurant.menuId : '';
    }
);

export const getChainRestaurants = createSelector(
    [getChainId, getRestaurants],
    (chainId, restaurants) => {
        return restaurants.filter(rest => rest.ownerId === chainId);
    }
);